import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
  name: "filters",
  initialState: {
    filterApplied: false,
    range: {
      startDate: null,
      endDate: new Date(),
      key: "range",
    },
    startTime: new Date(),
    endTime: new Date(),
    cameras: [],
    species: [],
  },
  reducers: {
    setTimeRange: (state, action) => {
      state.startTime = action.payload.startTime;
      state.endTime = action.payload.endTime;
    },
    setFilterApplied: (state, action) => {
      state.filterApplied = action.payload;
    },
    setDateRange: (state, action) => {
      state.range = action.payload;
    },
    setCameras: (state, action) => {
      // Handle the camera IDs properly
      let cameraIds = action.payload;
      // If there are merged IDs (from MultiSelect), flatten them
      if (Array.isArray(cameraIds)) {
        const flatIds = [];
        for (let i = 0; i < cameraIds.length; i++) {
          if (Array.isArray(cameraIds[i])) {
            flatIds.push(...cameraIds[i]);
          } else {
            flatIds.push(cameraIds[i]);
          }
        }
        state.cameras = flatIds;
      } else {
        state.cameras = cameraIds;
      }
    },
    setSpecies: (state, action) => {
      state.species = action.payload;
    },
    resetFilters: (state) => {
      state.filterApplied = false;
      state.range = {
        startDate: null,
        endDate: new Date(),
        key: "range",
      };
      state.startTime = new Date();
      state.endTime = new Date();
      state.cameras = [];
      state.species = [];
    },
  },
});

// Action creators
export const {
  setDateRange,
  setCameras,
  setSpecies,
  setFilterApplied,
  setTimeRange,
  resetFilters,
} = filterSlice.actions;
export const selectFilters = (state) => state.filters;

export default filterSlice.reducer;
